export const GLOBAL_LAYOUT_CONTAINER_CLASS = 'GlobalLayout__container';
export const GLOBAL_LAYOUT_ASIDE_CLASS = 'GlobalLayout__aside';
export const GLOBAL_LAYOUT_MAIN_WRAPPER_CLASS = 'GlobalLayout__main-wrapper';
export const GLOBAL_LAYOUT_PAGE_NAV_WRAPPER_CLASS =
  'GlobalLayout__page-nav-wrapper';
export const GLOBAL_LAYOUT_MAIN_CLASS = 'GlobalLayout__main';

import { DONATION_ROUTES } from '@/constants';

/** donation 데스크톱 헤더를 숨길 페이지 pathname 목록 */
export const HIDE_DONATION_HEADER_PATHNAMES: string[] = [
  DONATION_ROUTES.KB_CHECK_CARD.pathname,
];
